<div class="thank-you-wrap text-center px-20 py-30" *ngIf="step === 'success'">
  <div class="sucess-img-holder mb-25">
    <img src="/img/thank-you.svg" alt="sucess-icon" />
  </div>
  <div class="mb-20">
    @if (invite) {
      <h3 class="display-5 mb-12">Your account has been created!</h3>
      <span class="text-neutral-n7"> You can now log in with the email address this invitation was sent to and start testing. </span>
    } @else {
      <h3 class="display-5 mb-12">Thank you for signing up!</h3>
      <p class="display-6 mb-10">Check your email for a verification link to log in.</p>
      <span class="text-neutral-n7">
        Our team will contact you soon to proceed with the registration process, schedule a short introduction call and start the onboarding to the
        platform.
      </span>
    }
  </div>

  <a [routerLink]="['/login']" class="btn btn-primary">Start testing</a>
</div>

<div class="thank-you-wrap text-center px-20 py-30" *ngIf="step === 'invalid-invite'">
  <div class="sucess-img-holder mb-25">
    <img src="/img/sucess.svg" alt="sucess-icon" />
  </div>
  <h3 class="mb-20 display-5">Invalid Invitation</h3>
  <p>
    The invitation link has already been used or expired.<br />
    To proceed, please request a new invitation.
  </p>
</div>

<div class="thank-you-wrap text-center px-20 py-30" *ngIf="step === 'creating'">
  <div class="mb-20">
    <i class="icon icon-wait spin display-5 mb-20"></i>
    <h3 class="display-5 mb-12">Creating your account...</h3>
    <span class="text-neutral-n7">This will only take a moment.</span>
  </div>
</div>

<div *ngIf="step === 'main-info'" class="form-holder py-30 px-30">
  <h1 class="text-center mb-30">Create account</h1>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="reg-form">
    <div class="form-row">
      <div class="form-group">
        <label for="full-name" class="form-label required">Full Name </label>
        <input
          id="full-name"
          [(ngModel)]="model.fullName"
          formControlName="fullName"
          type="text"
          placeholder="Your Full Name"
          class="form-control"
          autocomplete="off"
          required />
        <input-errors [control]="form.controls.fullName" [service]="validationService"></input-errors>
      </div>

      <div *ngIf="!invite" class="form-group">
        <label for="Website" class="form-label required">Website </label>
        <input
          id="Website"
          [(ngModel)]="model.websiteUrl"
          formControlName="websiteUrl"
          type="text"
          autocomplete="off"
          placeholder="Your Business Website"
          class="form-control" />
        <input-errors [control]="form.controls.websiteUrl" [service]="validationService"></input-errors>
      </div>

      <div *ngIf="!invite" class="form-group">
        <label for="email" class="form-label required">Work Email </label>
        <input
          id="email"
          [(ngModel)]="model.email"
          formControlName="email"
          type="email"
          placeholder="you@company.com"
          class="form-control"
          autocomplete="off"
          required />
        <input-errors [control]="form.controls.email" [service]="validationService"></input-errors>
      </div>

      <div class="form-group">
        <label for="username" class="form-label required">Username </label>
        <div class="d-flex position-relative">
          <input
            id="username"
            [(ngModel)]="model.username"
            formControlName="username"
            type="text"
            placeholder="Your Username"
            class="form-control"
            autocomplete="off"
            required />
          <span
            class="icon-negative cp"
            tabindex="0"
            role="button"
            aria-label="Clear username"
            (click)="onClearUsername()"
            (keyup.enter)="onClearUsername()"></span>
        </div>
        <input-errors [control]="form.controls.username" [service]="validationService"></input-errors>
      </div>

      <div *ngIf="invite" class="form-group">
        <label for="Country" class="form-label required">Country </label>
        <select [(ngModel)]="inviteCountryCode" formControlName="countryCode" id="Country" class="form-control form-select input-sm">
          <option value="" disabled selected>Select your country</option>
          <option *ngFor="let country of countries" [value]="country.code">{{ country.name }}</option>
        </select>
        <input-errors [control]="form.controls.countryCode" [service]="validationService"></input-errors>
      </div>

      <div class="form-group">
        <label for="Phone" class="form-label required">Phone </label>
        <input id="Phone" [(ngModel)]="model.phone" formControlName="phone" type="text" class="form-control" placeholder="+441234567890" required />
        <input-errors [control]="form.controls.phone" [service]="validationService"></input-errors>
      </div>

      <hr />

      <div class="form-bottom">
        <div class="form-group position-relative">
          <label for="Create Password" class="form-label required">Create Password </label>
          <input
            id="Create Password"
            [(ngModel)]="model.password"
            formControlName="password"
            type="text"
            placeholder="Create Password"
            autocomplete="off"
            class="form-control"
            [type]="isPasswordType() ? 'password' : 'text'" />
          <span
            class="icon position-absolute"
            tabindex="0"
            role="button"
            aria-label="Toggle password visibility"
            (click)="togglePasswordType()"
            (keyup.enter)="togglePasswordType()"
            (keyup.space)="togglePasswordType()"
            [ngClass]="form.controls.password.pending ? 'icon-wait spin' : { 'icon-show': !isPasswordType(), 'icon-hide': isPasswordType() }"></span>
          <input-errors [control]="form.controls.password" [service]="validationService"></input-errors>
        </div>
      </div>

      <div class="note">Use 8 or more characters with a mix of letters, numbers & special characters like !&#64;#$%^&*()_+\-=[];':"|,.<>/?</div>

      <div *ngIf="!invite" class="form-group mt-20">
        <label for="Source" class="form-label">Source </label>
        <select [(ngModel)]="model.source" formControlName="source" id="Source" class="form-control form-select input-sm">
          <option *ngFor="let item of userService.sourceItems" [value]="item.id">{{ item.label }}</option>
        </select>
        <input-errors [control]="form.controls.source" [service]="validationService"></input-errors>
      </div>

      <div class="btn-holder">
        <button class="btn btn-primary" [disabled]="!form.valid || loading">
          <ng-container *ngIf="!loading">Create account</ng-container>
          <i *ngIf="loading" class="icon icon-wait spin"></i>
        </button>
      </div>
    </div>
  </form>
</div>

<div *ngIf="step === 'company-billing'" class="form-holder py-30 px-30">
  <h1 class="text-center mb-10">Company &amp; Billing Information</h1>
  <form (ngSubmit)="onCompanyBillingSubmit()" [formGroup]="companyBillingForm" class="reg-form">
    <div class="form-row">
      <div class="form-group">
        <label for="company" class="form-label required">Company Name </label>
        <input
          id="company"
          [(ngModel)]="companyBillingModel.companyName"
          formControlName="companyName"
          type="text"
          placeholder="Your Company Name"
          autocomplete="off"
          class="form-control"
          required />
        <input-errors [control]="companyBillingForm.controls.companyName" [service]="validationService"></input-errors>
      </div>

      <div class="form-group">
        <label for="billing-country" class="form-label required">Country </label>
        <select
          id="billing-country"
          [(ngModel)]="companyBillingModel.countryCode"
          formControlName="countryCode"
          class="form-control form-select input-sm">
          <option value="" disabled selected>Select country</option>
          <option *ngFor="let country of countries" [value]="country.code">{{ country.name }}</option>
        </select>
        <input-errors [control]="companyBillingForm.controls.countryCode" [service]="validationService"></input-errors>
      </div>

      <div class="d-flex justify-content-between gap-2 form-single-line">
        <div class="form-group">
          <label for="state" class="form-label">State </label>
          <input
            id="state"
            [(ngModel)]="companyBillingModel.addressState"
            formControlName="addressState"
            type="text"
            placeholder="State"
            autocomplete="off"
            class="form-control" />
          <input-errors [control]="companyBillingForm.controls.addressState" [service]="validationService"></input-errors>
        </div>
        <div class="form-group">
          <label for="city" class="form-label required">City </label>
          <input
            id="city"
            [(ngModel)]="companyBillingModel.addressCity"
            formControlName="addressCity"
            type="text"
            placeholder="City"
            autocomplete="off"
            class="form-control"
            required />
          <input-errors [control]="companyBillingForm.controls.addressCity" [service]="validationService"></input-errors>
        </div>
      </div>

      <div class="form-group">
        <label for="street" class="form-label required">Street </label>
        <input
          id="street"
          [(ngModel)]="companyBillingModel.addressStreet"
          formControlName="addressStreet"
          type="text"
          placeholder="Street"
          autocomplete="off"
          class="form-control"
          required />
        <input-errors [control]="companyBillingForm.controls.addressStreet" [service]="validationService"></input-errors>
      </div>

      <div class="d-flex justify-content-between gap-2 form-single-line">
        <div class="form-group">
          <label for="zip" class="form-label">ZIP </label>
          <input
            id="zip"
            [(ngModel)]="companyBillingModel.addressZip"
            formControlName="addressZip"
            type="text"
            placeholder="ZIP"
            autocomplete="off"
            class="form-control" />
          <input-errors [control]="companyBillingForm.controls.addressZip" [service]="validationService"></input-errors>
        </div>
        <div class="form-group">
          <label for="vat" class="form-label">
            VAT Number
            <span *ngIf="isBillingCountryNonEu()" class="icon-help-1 vat-tooltip" [attr.title]="getVatTooltipText()"></span>
          </label>
          <input
            id="vat"
            [(ngModel)]="companyBillingModel.vatNumber"
            formControlName="vatNumber"
            type="text"
            placeholder="VAT Number"
            autocomplete="off"
            class="form-control" />
          <input-errors [control]="companyBillingForm.controls.vatNumber" [service]="validationService"></input-errors>
        </div>
      </div>
      <div *ngIf="getVatHelperText()" class="vat-helper">
        {{ getVatHelperText() }}
      </div>

      <div class="btn-holder">
        <button class="btn btn-primary" [disabled]="!companyBillingForm.valid || loading">
          <ng-container *ngIf="!loading">Submit company details</ng-container>
          <i *ngIf="loading" class="icon icon-wait spin"></i>
        </button>
      </div>
    </div>
  </form>
</div>
